module.exports = __webpack_public_path__ + "static/media/Listlist-01.1e0bc18b.png";